
export enum CustomerInvoiceCd {
	BAL_DUE = 'BalDue',
	CORRECTED = 'Corrected',
	ORIGINAL = 'Original',
	TRUE_DEBTOR = 'TrueDebtor'}
